import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Tappable, { simpleActiveBackgroundColor } from "nx-components/Tappable";
import TileBody from "nexia_mobile/components/Tiles/TileBody";
import TileSpinner from "nexia_mobile/components/Tiles/TileSpinner";
import IconGroupTileWrapper from "nexia_mobile/components/Tiles/IconGroupTileWrapper";
import IconGroup from "nexia_mobile/components/IconGroup";
import parseIconsFromServer from "nexia_mobile/parseIconsFromServer";
import { createTileControlForAutomation } from "nexia_mobile/components/Controls/createControlsForModel";
import { history } from "nexia_mobile/history";
import { getTransitionPromise } from "nexia_mobile/components/Routing/HistoryPageTransitionController";

export default class AutomationTile extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    tileStyles: PropTypes.shape({
      contents: PropTypes.object.isRequired,
      icon: PropTypes.object.isRequired,
      title: PropTypes.object.isRequired,
      status: PropTypes.object.isRequired,
    }).isRequired,
  };

  state = {
    spinnerShown: false,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _showSpinner = () => {
    if (this._isMounted) {
      this.setState({ spinnerShown: true });
    }
  };

  _hideSpinner = () => {
    if (this._isMounted) {
      this.setState({ spinnerShown: false });
    }
  };

  _handleTap = () => {
    const { model } = this.props;
    history.push("/app/automations/details", { automation: model });
  };

  render() {
    const { model, tileStyles } = this.props;
    const { spinnerShown } = this.state;

    let icons = model.get("icon");
    let automationName = model.get("name");
    const iconValues = parseIconsFromServer(icons, { ignoreModifiers: true });

    return (
      <Tappable onTap={this._handleTap} holdActiveUntil={getTransitionPromise}>
        {({ active, tapTargetRefHandler }) => (
          <div
            data-component-name="AutomationTile"
            className="tile-contents"
            style={{
              ...tileStyles.contents,
              backgroundColor: simpleActiveBackgroundColor(active),
            }}
          >
            <TileBody innerRef={tapTargetRefHandler} hasControls>
              <IconGroupTileWrapper values={iconValues} unique>
                <IconGroup
                  className="tile-icon"
                  style={tileStyles.icon}
                  values={iconValues}
                  showJoinIcon
                  unique
                />
              </IconGroupTileWrapper>
              <div className="tile-title" style={tileStyles.title}>
                {automationName}
              </div>
            </TileBody>
            {createTileControlForAutomation(model, {
              showSpinner: this._showSpinner,
              hideSpinner: this._hideSpinner,
            })}
            {spinnerShown ? <TileSpinner /> : null}
          </div>
        )}
      </Tappable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tiles/AutomationTile.jsx